<div  v-if="shouldRenderConfig" v-bind:class="getClassName">
    <button type="button" class="matrix_pageOptionAttributeButton" v-bind:class="activeClass()" v-on:click="setPageOption({value:value, layout:true, optionType:'main'})">
        <div v-bind:class="getClassName + 'InnerContainer'">            
            <div v-bind:class="getClassName + 'Image'">
                <img :src="imageSrc" v-if="imageSrc" />
                <span v-if="!imageSrc">
                    {{$t("Image placeholder")}}
                </span>
            </div>
            <div v-bind:class="getClassName + 'Name'">{{name}}</div>    
        </div>
        <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
    </button>
</div>